import axios, { AxiosResponse } from "axios";
import { tokenManager } from "@libs/token-manager";

axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  async error => {
    if (error.code === "ERR_CANCELED") {
      return Promise.resolve();
    }

    if (error.response?.status === 401 || error.response?.status === 403) {
      document.dispatchEvent(new Event("axios:unauthorized"));
    }

    console.error(error);

    return Promise.reject(error);
  },
);

axios.interceptors.request.use(config => {
  const jwt = tokenManager.getAccessToken();

  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = jwt ? `Bearer ${jwt}` : null;
  return config;
});
